<template>
    <div>
        <vFormItem
            :label="$t('fbb.warehouse.can_use_warehouse', { defaultValue: '可使用的仓库'})"
            label-width="150"
            v-if="type !== 'query'"
        >
            <vTransfer
                style="height:360px;"
                :data="warehouseList"
                identifier="value"
                :target-keys="targetKeys"
                :list-style="listStyle"
                :render-format="renderFormat"
                :filter-method="filterMethod"
                filterable
                @on-transfer="handleChange"
            ></vTransfer>
        </vFormItem>
        <TableList v-else v-bind="getTableProps"></TableList>
    </div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpOrgWarehouseService, HttpOrgServiceWarehouseList } from "@/service/basicdata";
import { mapGetters } from 'vuex';
export default {
    // props: ['data'],
    components: {
        TableList
    },
    data() {
        return {
            type: this.$route.params.type,
            id: this.$route.query.id,
            orgId: this.$route.query.orgId || this.data,
            targetKeys: [],
            listStyle: {
                width: "30%",
                minWidth: "260px"
            },
            warehouseList: [],
        };
    },
    created() {
        this.getWarehouseList();
        this.getTargetKeys();
    },
    // watch: {
    //     data(val) {
    //         if (this.type === 'add') {
    //             this.orgId = val;
    //             this.targetKeys=[];
    //             this.getWarehouseList();
    //         }
    //     },
    // },
    computed: {
        ...mapGetters('dictionary', ['getSystemWareList']),
        getTableProps() {
            return {
                ajaxRequest: HttpOrgWarehouseService,
                startUp: 1,
                initFormData: {
                    orgId: this.orgId,
                },
                columns: [
                    {
                        title: this.$t('fbb.warehouse.sequence', { defaultValue: "序号" }),
                        type: "index",
                        width: 100
                    },
                    {
                        title: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
                        key: "warehouseId",
                        render: (h, { row }) =>
                            this.findRenderLabel(this.getSystemWareList, row.key)
                    }
                ]
            };
        }
    },
    methods: {
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
        handleChange(targetKeys, direction, moveKeys) {
            this.targetKeys = targetKeys;
        },
        //获取仓库list
        async getTargetKeys() {
            if (this.type === 'add') return;
            HttpOrgWarehouseService({
                page: 1,
                rows: 2000,
                orgId: this.orgId,
            }).then(res => {
                const data = res.data || {};
                this.targetKeys = data.content || []
            })
        },
        async getWarehouseList() {
            HttpOrgServiceWarehouseList().then(res => {
                this.warehouseList = (res.data || []).map(item => {
                    return {
                        value: item.id,
                        label: `${item.code}(${item.title})`
                    }
                })
            }).catch(err => {
                this.warehouseList = [];
            })
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
    }
};
</script>
